import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useInitialValues = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		let shouldUpdate = false;

		if (!searchParams.has("craft")) {
			searchParams.set("craft", "A");
			shouldUpdate = true;
		}

		if (!searchParams.has("type")) {
			searchParams.set("type", "A");
			shouldUpdate = true;
		}

		if (shouldUpdate) setSearchParams(searchParams, { replace: true });
	}, [searchParams]);
};
